import { faComment } from "@jewlr/pro-regular-svg-icons/faComment"
import { faCommentsAlt } from "@jewlr/pro-regular-svg-icons/faCommentsAlt"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_GE_CHECKOUT, jewlr_t } from "helpers/application"
import { handleLiveChat } from "live-chat"

import { LinkButton } from "./components"
import FooterAccordion from "./footer-accordion"

const HelpFooter = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  const deliveryFaq = [
    {
      content: (
        <p className="text-14 leading-16 mb-16 font-light">
          Once an order is confirmed, we handcraft your{" "}
          {jewlr_t("terms.jewelry")} right away. After passing quality control,
          we ship your order to your chosen destination. Contact us as soon as
          possible if you need to change your order.
        </p>
      ),
      title: "What happens when I place my order?",
    },
    {
      content: (
        <p className="text-14 leading-16 mb-16 font-light">
          {jewlr_t("terms.Personalized")} items are made-to-order, and based on
          the delivery method, the date displayed includes the time for crafting
          and {jewlr_t("terms.shipping")} your item.
        </p>
      ),
      title: "How long will it take?",
    },
    {
      content: (
        <p className="text-14 leading-16 mb-16 font-light">
          All orders proudly {jewlr_t("terms.ship")} from the USA and Canada,
          where the {jewlr_t("terms.jewelry")} is made.
        </p>
      ),
      title: `Where does my order ${jewlr_t("terms.ship")} from?`,
    },
  ]

  return (
    <section
      aria-labelledby="cart-help-heading"
      className="border-grey-20 border bg-white px-24 pb-12 pt-24"
    >
      <div className="tablet:mb-16 tablet:justify-start mb-8 flex items-center justify-center gap-8">
        <FontAwesomeIcon
          className="tablet:block text-16 hidden"
          icon={faCommentsAlt}
        />
        <h2 className="text-18 leading-22 font-bold" id="cart-help-heading">
          Need Help?
        </h2>
      </div>
      <div className="tablet:hidden flex justify-center">
        <Button
          className="mb-32 max-w-full rounded py-8 font-bold"
          onClick={() => handleLiveChat()}
          size="lg"
          variant="secondary"
        >
          <div className="mr-8">
            <FontAwesomeIcon icon={faComment} />
          </div>
          LIVE CHAT NOW!
        </Button>
      </div>
      <p className="text-12 leading-14 mb-16 font-medium">
        Call Toll Free{" "}
        <LinkButton
          className="text-12 tablet:font-bold inline font-bold"
          rel="nofollow"
          to={`tel:${sl.config.customer_service_toll_free}`}
          underline={false}
        >
          {sl.config.customer_service_toll_free}
        </LinkButton>{" "}
        or Email{" "}
        <LinkButton
          className="text-12 tablet:font-bold inline font-bold"
          rel="nofollow"
          to={`mailto:${sl.config.customer_service_email}`}
          underline={false}
        >
          {sl.config.customer_service_email}
        </LinkButton>
      </p>
      <FooterAccordion
        id={`${is_ge_checkout ? "30" : "99"}-day-returns-warranty`}
        title={`${is_ge_checkout ? "30" : "99"}-Day Returns & Included Warranty`}
      >
        <p className="text-14 leading-16 mb-16 font-light">
          You may return your purchase for a full refund (minus any{" "}
          {jewlr_t("terms.shipping")} charges) within{" "}
          {is_ge_checkout ? "30" : "99"} days of the original{" "}
          {jewlr_t("terms.shipping")} date.
        </p>
        <p className="text-14 leading-16 mb-16 font-light">
          We offer a 1-year manufacturer&apos;s warranty on all{" "}
          {jewlr_t("terms.jewelry")}.
        </p>
        <LinkButton asChild className="text-12 mb-16">
          <Link
            data-lc="footer"
            to="/helpdesk/5e9f516d2c7d3a7e9aeb5bfe/5ea1f1682c7d3a7e9aeb8748"
          >
            Read More About Warranty
          </Link>
        </LinkButton>
      </FooterAccordion>
      <FooterAccordion id="delivery-order-faq" title="Delivery & Order FAQ">
        <div className="pl-8">
          {deliveryFaq.map(({ content, title }) => (
            <FooterAccordion key={title} subAccordion title={title}>
              {content}
            </FooterAccordion>
          ))}
        </div>
        <LinkButton asChild className="text-12 my-12 ml-8">
          <Link
            data-lc="footer"
            to="/helpdesk/5e9f516d2c7d3a7e9aeb5bfe/5ea1ec7b04286364bc98e7ba"
          >
            Read More About {jewlr_t("terms.Shipping")}
          </Link>
        </LinkButton>
      </FooterAccordion>
    </section>
  )
}

export default HelpFooter
